import { css } from 'styled-components';
import { rgba } from 'polished';
import { FONT_SIZE } from './font';

// Viewports
/**
 * List of viewports. Each name is rounded to the "whole 100", e.g. 480 to 4 so the name is V4.
 * @type {{V7: string, V9: string, V12: string, V4: string}}
 */
export const SCREEN = {
	SMALL: '@media screen and (max-width: 480px)',
	MEDIUM: '@media screen and (max-width: 768px)',
	LARGE: '@media screen and (max-width: 992px)',
	EXTRA_LARGE: '@media screen and (max-width: 1200px)',
	NO_HOVER: '@media (hover: none)',
};

/**
 * Number to scale spacing based on the screen size
 * @type {{SMALL: number, MEDIUM: number, LARGE: number}}
 */
export const SCREEN_RATIO = {
	SMALL: 2.5,
	MEDIUM: 1.5,
	LARGE: 1.2,
};

// Colors
export const COLORS = {
	BLUE_LIGHT: '#f1f7ff',
	BLUE_DARK: '#00a2ff',
	DARK_BLUE: '#171C3B',
	MAIN_PURPLE: '#7F84FF',
	MAIN_GREEN: '#73D79F',
	LIGHT_GREEN: '#87DFAE',
	MAIN_RED: '#F32000',
	WHITE: '#ffffff',
	GRAY_LIGHTEST: '#fafafa',
	GRAY_LIGHT: '#dadada',
	GRAY_DARK: '#666a73',
	GRAY_DARKER: '#444752',
};

// List of colors used for titles, headings, paragraphs, texts
export const TEXT_COLORS = {
	BASE: COLORS.GRAY_DARK,
	HEADING: COLORS.GRAY_DARKER,
	LIGHT: COLORS.GRAY_LIGHTEST,
	BLUE: COLORS.BLUE_DARK,
	WHITE: COLORS.WHITE,
};

/**
 * List of weights
 * @type {{SEMI_BOLD: string, BOLD: string, NORMAL: string}}
 */
export const WEIGHTS = {
	NORMAL: 'normal',
	SEMI_BOLD: '600',
	BOLD: '800',
};

export const FONT_FAMILY = {
	proximaNova: css`
		font-family: "Proxima Nova", serif;
	`,
	proximaNovaSoft: css`
		font-family: "Proxima Nova Soft", serif;
	`,
};

// SPACE VALUES
export const SPACE = {
	XSMALL: 8,
	SMALL: 16,
	SMEDIUM: 24,
	MEDIUM: 32,
	XMEDIUM: 48,
	LARGE: 64,
	XLARGE: 80,
	XXLARGE: 120,
};
